module.exports = __webpack_public_path__ + "media/right.c3157643.mp3";